export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        if (!this.importedUsers) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.activeAccounts = this.connectionDetails.activeAccounts;
        this.pendingAccounts = this.connectionDetails.pendingAccounts;
        this.allAccounts = this.activeAccounts + this.pendingAccounts;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/bulk-verification-result/bulk-verification-result.controller.js